import gql from "graphql-tag";
const UPDATEPROFILE_MUTATIONS = gql`
  mutation updateUserProfile($updateUserInput: UpdateUserProfileInput!) {
    updateUserProfile(updateUserInput: $updateUserInput) {
      success
      message
      err
    }
  }
`;

export default UPDATEPROFILE_MUTATIONS;
